import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { PrimaryLayout, AdditionalLayout, UOMLayout,  StatusLayout, CodesLayout,RefrencesLayout } from '../Layout';


function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    // const formRefs = useRef({});
    const combinedLayouts = [
        { name: 'PrimaryLayout', layout: PrimaryLayout },
        { name: 'AdditionalLayout', layout: AdditionalLayout },
        { name: 'UOMLayout', layout: UOMLayout },
        { name: 'StatusLayout', layout: StatusLayout },
        { name: 'CodesLayout', layout: CodesLayout },
        { name: 'RefrencesLayout', layout: RefrencesLayout }

    ];
    
    const updatedLayouts = combinedLayouts.map(({ name, layout }) => {
        if (name !== 'PrimaryLayout') {
            return layout.map(group => ({
                ...group,
                label: "", 
                fields: group.fields.map(field => ({
                    ...field,
                    visible: false
                }))
            }));
        }
        return layout;
    });
    
    const finalLayout = updatedLayouts.flat();

    const handlePrimaryFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad();

    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='58DBDDD6-C7A6-41D1-A3DE-54F013344BB7'
                layoutName='IMItemDataEntryPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
